















import { Component, Prop, Vue } from 'vue-property-decorator';
import store from '@/store'; // @ is an alias to /src

@Component({components: {}})
export default class Error extends Vue {
  private code?: number = 0;
  private message?: string = 'Sorry! it looks like something has gone wrong!';

  constructor() {
    super();
  }
  public async created() {
    // 1
  }
  public async mounted() {
    // 2
    this.code = this.$store.state.errorCode;
    this.message = this.$store.state.errorMessage;
    // console.log('Error: ', this.code, this.message);
  }

  private async retryBack() {
    this.$router.go(-1);
  }
}
